import {
  ORGANISATION_LIST_GET_SUCCESS,
  ORGANISATION_GET_SUCCESS,
  ORGANISATION_CREATE_SUCCESS,
  ORGANISATION_UPDATE_SUCCESS,
  ORGANISATION_UPDATE_ERROR,
  ORGANISATION_DELETE_SUCCESS,
  ORGANISATION_DELETE_ERROR,
  ORGANISATION_LIST_GET_REQUEST,
  ORGANISATION_LIST_GET_IN_PROGRESS,
  ORGANISATION_LIST_GET_ERROR,
  ORGANISATION_SELECT_SUCCESS,
} from 'src/store/organisation/actions'
import { getIdsFromList, getByIdFromList } from 'src/utils/store'

export const getInitialState = {
  status: null,
  data: null,
  error: null,
  byId: null,
  statusById: null,
  errorById: null,
}

export const reducer = (state = getInitialState, action) => {
  const { type, payload } = action
  const { uuid } =
    typeof payload === 'string' ? { uuid: payload } : payload || {}

  switch (type) {
    case ORGANISATION_LIST_GET_REQUEST:
    case ORGANISATION_LIST_GET_IN_PROGRESS:
    case ORGANISATION_LIST_GET_ERROR:
      return {
        ...state,
        status: type,
      }
    case ORGANISATION_LIST_GET_SUCCESS:
      return {
        ...state,
        status: type,
        data: getIdsFromList(payload),
        byId: getByIdFromList(payload),
        statusById: getIdsFromList(payload).reduce(
          (status, id) => ({
            ...status,
            [id]: type,
          }),
          {}
        ),
        errorById: {},
      }
    case ORGANISATION_GET_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      return {
        ...restState,
        data: data.indexOf(uuid) > -1 ? data : [...data, uuid],
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case ORGANISATION_CREATE_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      return {
        ...restState,
        data: [...data, uuid],
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case ORGANISATION_UPDATE_SUCCESS: {
      const { byId, statusById, ...restState } = state
      return {
        ...restState,
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case ORGANISATION_UPDATE_ERROR: {
      const { statusById, errorById, ...restState } = state
      return {
        ...restState,
        statusById: {
          ...statusById,
          [uuid]: type,
        },
        errorById: {
          ...errorById,
          [uuid]: payload,
        },
      }
    }
    case ORGANISATION_DELETE_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      delete byId[uuid]
      return {
        ...restState,
        data: data.filter((id) => id !== uuid),
        byId: { ...byId },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case ORGANISATION_DELETE_ERROR: {
      const { statusById, errorById, ...restState } = state
      return {
        ...restState,
        statusById: {
          ...statusById,
          [uuid]: type,
        },
        errorById: {
          ...errorById,
          [uuid]: payload,
        },
      }
    }
    case ORGANISATION_SELECT_SUCCESS:
      return {
        ...state,
        selected: uuid,
      }
    default:
      return state
  }
}

export default reducer
